import { Sun, Home, ArrowLeftRight, Zap, Gauge } from "lucide-react";

const STEPS = [
  { icon: Sun, title: "Panels generate energy", desc: "Sunlight becomes DC electricity, then inverted to home-ready AC.", color: "#D97706" },
  { icon: Home, title: "Home uses what it needs", desc: "Your appliances draw solar first before touching the grid.", color: "#0F382C" },
  { icon: ArrowLeftRight, title: "Excess flows to the grid", desc: "Overproduction is exported to the utility, tracked to the kilowatt-hour.", color: "#C2410C" },
  { icon: Zap, title: "Home pulls back when needed", desc: "At night or on cloudy days, electricity flows back from the grid.", color: "#B45309" },
  { icon: Gauge, title: "The meter tracks the exchange", desc: "A bi-directional meter records what you send out and what you draw in.", color: "#164E3D" },
];

export default function NetMeteringDiagram() {
  return (
    <section className="py-20 md:py-28 bg-[#F7F4EB]" data-testid="net-metering-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="eyebrow" data-testid="net-metering-eyebrow">Virginia Net Metering</div>
          <h2 className="mt-3 font-serif-display text-3xl md:text-5xl font-semibold text-[#0F382C]">
            The agreement between your home and the utility to exchange clean energy back and forth.
          </h2>
          <p className="mt-5 text-lg text-slate-600">
            Each qualifying kilowatt-hour you send to the grid can offset a kilowatt-hour you use later — subject to your utility's rules. It lets the grid function like a virtual energy bank so you can benefit from daytime overproduction without storing every excess kWh in a battery.
          </p>
        </div>

        <ol className="mt-12 grid grid-cols-1 md:grid-cols-5 gap-4 md:gap-3 relative">
          {STEPS.map((s, i) => (
            <li key={i} className="card-warm p-6 relative" data-testid={`net-metering-step-${i + 1}`}>
              <div className="flex items-center justify-between mb-4">
                <div
                  className="w-11 h-11 rounded-xl flex items-center justify-center"
                  style={{ background: `${s.color}18` }}
                >
                  <s.icon className="w-5 h-5" style={{ color: s.color }} />
                </div>
                <span className="font-mono-metric text-xs tracking-widest text-slate-400">0{i + 1}</span>
              </div>
              <div className="font-serif-display text-lg text-[#0F382C] leading-snug">{s.title}</div>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
            </li>
          ))}
        </ol>

        <div className="mt-10 rounded-2xl border border-[#E5E0D8] bg-white p-6 md:p-8 grid md:grid-cols-3 gap-6">
          <div>
            <div className="eyebrow">Last Updated</div>
            <div className="font-mono-metric text-base mt-2 text-[#0F382C]">Jan 15, 2026</div>
          </div>
          <div className="md:col-span-2 text-sm text-slate-600 leading-relaxed">
            Utility rules and credit values change. Regulatory changes can affect the economics of solar. See your specific utility's net-metering tariff for exact terms.
          </div>
        </div>
      </div>
    </section>
  );
}
